import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6553f37e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "formContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white"
  }
}, "重新上传", -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "企业名称", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "店铺名称", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "联系人", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "手机号码", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "地址", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "门牌号", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "类型", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "所属社区", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "社会信用代码", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "到期时间", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "搬迁/停业", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inputName"
}, "营业执照", -1));
const _hoisted_16 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OssUploader = _resolveComponent("OssUploader");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_col = _resolveComponent("el-col");
  const _component_Location = _resolveComponent("Location");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_OssUploader, {
      "allowed-file-types": ['jpeg', 'png', 'jpg'],
      onOnUploaded: _cache[0] || (_cache[0] = u => $data.shop.shopImage = u)
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        style: _normalizeStyle({
          width: '260px',
          height: '200px',
          backgroundImage: `url(${$data.shop.shopImage ? $data.shop.shopImage : $data.defaults.bg})`,
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat'
        }),
        class: "bothCenter"
      }, _hoisted_3, 4)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_4, _createVNode(_component_el_input, {
        placeholder: "请输入企业名称",
        modelValue: $data.shop.licenseName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.shop.licenseName = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_5, _createVNode(_component_el_input, {
        placeholder: "请输入店铺名称",
        modelValue: $data.shop.shopName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.shop.shopName = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_6, _createVNode(_component_el_input, {
        placeholder: "请输入联系人",
        modelValue: $data.shop.contactName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.shop.contactName = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_7, _createVNode(_component_el_input, {
        placeholder: "请输入手机号码",
        modelValue: $data.shop.contactInfo,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.shop.contactInfo = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea"
  }, {
    default: _withCtx(() => [_hoisted_8, _createVNode(_component_el_input, {
      placeholder: "请输入地址",
      modelValue: $data.shop.address,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.shop.address = $event)
    }, {
      append: _withCtx(() => [_createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Location)]),
          _: 1
        }), _createTextVNode(" 定位 ")]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea"
  }, {
    default: _withCtx(() => [_hoisted_9, _createVNode(_component_el_input, {
      placeholder: "请输入门牌号",
      modelValue: $data.shop.doorCode,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.shop.doorCode = $event)
    }, {
      prepend: _withCtx(() => [_createVNode(_component_el_select, {
        placeholder: "请选择",
        style: {
          "width": "200px",
          "background-color": "white"
        },
        modelValue: $data.shop.streetId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.shop.streetId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.streets, cc => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: cc.label,
            value: cc.value,
            key: cc.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "rowFlex"
    }, {
      default: _withCtx(() => [_hoisted_10, _createVNode(_component_el_select, {
        placeholder: "请选择",
        style: {
          "background-color": "white"
        },
        modelValue: $data.shop.shopType,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.shop.shopType = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shopTypes, cc => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: cc.label,
            value: cc.value,
            key: cc.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12,
      class: "rowFlex"
    }, {
      default: _withCtx(() => [_hoisted_11, _createVNode(_component_el_select, {
        placeholder: "请选择",
        style: {
          "background-color": "white"
        },
        modelValue: $data.shop.communityId,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.shop.communityId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.communities, cc => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: cc.label,
            value: cc.value,
            key: cc.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_12, _createVNode(_component_el_input, {
        placeholder: "请输入企业社会信用代码",
        modelValue: $data.shop.licenseCode,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.shop.licenseCode = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_hoisted_13, _createVNode(_component_el_input, {
        placeholder: "请输入到期时间",
        modelValue: $data.shop.licenseExpireTime,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.shop.licenseExpireTime = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "rowFlex"
    }, {
      default: _withCtx(() => [_hoisted_14, _createVNode(_component_el_select, {
        placeholder: "请选择",
        style: {
          "background-color": "white"
        },
        modelValue: $data.shop.state,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.shop.state = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "正常经营",
          value: "0"
        }), _createVNode(_component_el_option, {
          label: "搬迁/停业",
          value: "1"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "inputArea",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "rowFlex"
    }, {
      default: _withCtx(() => [_hoisted_15, _createVNode(_component_OssUploader, {
        "allowed-file-types": ['jpeg', 'png', 'jpg'],
        onOnUploaded: _cache[13] || (_cache[13] = u => $data.shop.licenseImage = u)
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          style: {
            "width": "200px",
            "height": "200px",
            "object-fit": "cover"
          },
          src: $data.shop.licenseImage ? $data.shop.licenseImage : $data.defaults.uploader
        }, null, 8, _hoisted_16)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "rightCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      style: {
        "width": "120px"
      },
      onClick: _cache[14] || (_cache[14] = $event => _ctx.$emit('cancel'))
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      style: {
        "width": "120px"
      },
      onClick: $options.save
    }, {
      default: _withCtx(() => [_createTextVNode("保存")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })]);
}